'use strict';

var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return str.replace(matchOperatorsRe, '\\$&');
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap-typeahead/~/escape-string-regexp/index.js
 ** module id = 818
 ** module chunks = 0
 **/